import React, { createContext, useContext, useState } from 'react';
import { AuthService } from './AuthService';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);

  const login = async (username, password) => {
    try {
      const user = await AuthService.login(username, password);
      setCurrentUser(user);
      setTimeout(() => {
        // Logout user after 1 hour
        logout();
      }, 3600000); // 1 hour in milliseconds
      return user;
    } catch (error) {
      throw error;
    }
  };

  const logout = () => {
    AuthService.logout();
    setCurrentUser(null);
  };

  return (
    <AuthContext.Provider value={{ currentUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
